import fetch from 'isomorphic-fetch';

export default (links, csrf) => {
  setTimeout(() => {
    fetch('/merchantapps/api/v1/batchImpressions', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrf
      },
      body: JSON.stringify(links)
    });
  }, 3500);
};
